// The three signs' names, what each stands for, and their glyphs: the sun
// as the astronomer's ☉, the moon as a crescent, the rising as a half sun on
// the horizon. Drawn at 24 like the icons, in strokes of the current color.
import type { Sign } from '../../systems/api/types';

export const SIGN_LABELS: Record<Sign, string> = { sun: 'Sun', moon: 'Moon', rising: 'Rising' };

/** One line on what a sign is, for the picker. */
export const SIGN_MEANINGS: Record<Sign, string> = {
  sun: 'Who you are at heart.',
  moon: 'Your inner weather.',
  rising: 'How you meet the world.',
};

export function SignGlyph({ sign, className }: { sign: Sign; className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={['icon', 'sign-glyph', className ?? ''].join(' ').trim()} aria-hidden="true">
      {sign === 'sun' && (
        <>
          <circle cx="12" cy="12" r="7.5" />
          <circle cx="12" cy="12" r="1.6" fill="currentColor" stroke="none" />
        </>
      )}
      {sign === 'moon' && <path d="M15.5 4.2a8 8 0 1 0 4.3 12.9A6.6 6.6 0 0 1 15.5 4.2z" />}
      {sign === 'rising' && <path d="M3.5 17.5h17M7 17.5a5 5 0 0 1 10 0M12 9.5V4.5M9.8 6.7L12 4.5l2.2 2.2" />}
    </svg>
  );
}
